export default __webpack_public_path__ + "static/media/Mark-6-3D-Model-01.4abef42e.jpg";